<div class="d-flex justify-content-center">
  <img class="ml-2"
       style="height: 30px"
       src="./assets/images/bill_fuel_yes.png" alt=""
       *ngIf="rowData?.doNotRebillFuel === false || rowData?.doNotRebillFuel === null">
  <img class="ml-2"
       style="height: 30px"
       src="./assets/images/bill_fuel_no.png" alt=""
       *ngIf="rowData?.doNotRebillFuel === true">
</div>
